import * as React from "react";
import { SVGProps } from "react";

const PolymathNetwork = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 445 275" {...props}>
    <path fill="#3f4b80" d="M378.3 43.8 360 30.5l42.8-21.6-24.5 34.9z" />
    <path fill="#313a62" d="m269.5 0 53.3 27.4 6.4 44.2L269.5 0z" />
    <path fill="#3f4b80" d="m329.2 71.6-8.5 37.6L269.5 0l59.7 71.6z" />
    <path fill="#4b5897" d="m320.7 109.2-81.6-103 30.5-6 51.1 109z" />
    <path fill="#5161a4" d="m320.7 109.2-88.5-34.6 6.9-68.4 81.6 103z" />
    <path fill="#4b5897" d="m239.1 6.2-6.9 68.4L141 87.4l98.1-81.2z" />
    <path fill="#4b5897" d="m320.7 109.2-97.6 26.5 9.1-61.1 88.5 34.6z" />
    <path
      fill="#3f4b80"
      d="m223.1 135.7 97.6-26.5-44 20.5-53.6 6zm-53.9 9.2 53.9-9.2.9 18.4-54.8-9.2z"
    />
    <path fill="#313a62" d="m224 154.1-.9-18.4 53.6-6-52.7 24.4z" />
    <path fill="#3f4b80" d="m141 87.4 91.2-12.8-9.1 61.1L141 87.4z" />
    <path fill="#4b5897" d="m141 87.4 82.1 48.3-53.9 9.2L141 87.4z" />
    <path fill="#313a62" d="m141 87.4 28.2 57.5-27.2 19.9-1-77.4z" />
    <path fill="#5161a4" d="m94.7 102.9 10.9 65.5-30-45.1 19.1-20.4z" />
    <path fill="#313a62" d="m41 123.7 34.6-.4.2 21.1L41 123.7z" />
    <path fill="#3f4b80" d="M43.8 138 41 123.7l34.8 20.7-32-6.4z" />
    <path fill="#4b5897" d="M43.8 138 24 155.5l17-31.8 2.8 14.3z" />
    <path fill="#313a62" d="m24 155.5-1.4 10.6L0 162.4l24-6.9z" />
    <path fill="#5161a4" d="M24 155.5 43.8 138l-21.2 28.1 1.4-10.6z" />
    <path
      fill="#3f4b80"
      d="m75.6 123.3 30 45.1-29.8 5.9-.2-51zm8.8 84.6-21.7 44.9-3.2-34.6 24.9-10.3z"
    />
    <path fill="#1f243e" d="m59.5 218.2 3.2 34.6-12.5 6 9.3-40.6z" />
    <path fill="#3f4b80" d="m62.7 252.8 3.3 16.9-25.8 5.3 22.5-22.2z" />
    <path
      fill="#313a62"
      d="m50.2 258.8 12.5-6L40.2 275l10-16.2zm25.6-84.5 29.8-5.9-46.1 49.8 16.3-43.9z"
    />
    <path fill="#4b5897" d="m105.6 168.4 20.3 23.1-66.4 26.7 46.1-49.8z" />
    <path fill="#4b5897" d="M94.7 102.9 141 87.4l-35.4 81-10.9-65.5z" />
    <path fill="#3f4b80" d="m105.6 168.4 35.4-81 1 77.4-36.4 3.6z" />
    <path fill="#313a62" d="m125.9 191.5-20.3-23.1 36.4-3.6-16.1 26.7z" />
    <path fill="#4b5897" d="m276.7 129.7 42.9-.3-27.4 41.8-15.5-41.5z" />
    <path fill="#5161a4" d="m276.7 129.7 44-20.5-1.1 20.2-42.9.3z" />
    <path fill="#3f4b80" d="m268.3 166.7 8.4-37 15.5 41.5-23.9-4.5z" />
    <path fill="#4b5897" d="m258 186.1 10.3-19.4 23.9 4.5-34.2 14.9z" />
    <path fill="#3f4b80" d="m237.2 200 6.5-31.8 24.6-1.5-31.1 33.3z" />
    <path fill="#313a62" d="m237.2 200 31.1-33.3-10.3 19.4-20.8 13.9z" />
    <path fill="#495692" d="m360 30.5 40.8-28.6 2 7L360 30.5z" />
    <path fill="#5d6cac" d="M400.8 1.9 434.2.2l-31.4 8.7-2-7z" />
    <path fill="#4f60a3" d="m379.4 67.2-18.6-13.1 62.9.1-44.3 13z" />
    <path fill="#495692" d="m360.8 54.1 54.1-7 8.8 7.1-62.9-.1z" />
    <path fill="#3f4b80" d="m414.9 47.1 24.8-21.7-16 28.8-8.8-7.1z" />
    <path fill="#4f60a3" d="m423.7 54.2 16-28.8 5.3 2.5-21.3 26.3z" />
    <path
      fill="#313a62"
      d="m439.7 25.4 4.4-12.5.9 15-5.3-2.5zM329.2 71.6l6 52.6-14.5-15 8.5-37.6z"
    />
    <path fill="#3f4b80" d="m335.2 124.2-6-52.6 50.2-4.4-44.2 57z" />
    <path fill="#4b5897" d="m379.4 67.2-50.2 4.4-6.4-44.2 56.6 39.8z" />
    <path fill="#313a62" d="m378.3 43.8 8.1 7.3-25.6 3 17.5-10.3z" />
    <path fill="#3f4b80" d="m322.8 27.4 55.5 16.4-17.5 10.3-38-26.7z" />
    <path fill="#313a62" d="m322.8 27.4 37.2 3.1 18.3 13.3-55.5-16.4z" />
    <path fill="#3f4b80" d="m377.1 150.4 2.3-83.2 20 16.3-22.3 66.9z" />
    <path fill="#495692" d="m377.1 150.4 2.3-83.2-44.2 57 41.9 26.2z" />
    <path
      fill="#313a62"
      d="M399.4 83.5 393 62.7l-13.6 4.5 20 16.3zm2.7 55.4-25 11.5 22.3-66.9 2.7 55.4z"
    />
  </svg>
);

export default PolymathNetwork;
